import React from 'react';
import PropTypes from 'prop-types';
export default class Content extends React.Component {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.content } })));
    }
}
Content.propTypes = {
    content: PropTypes.string,
};
Content.defaultProps = {
    content: '',
};
